import { Scene, Raycaster, MeshBasicMaterial, Mesh, PlaneGeometry, Vector3, PerspectiveCamera, Vector2 } from "three";
import { Main } from "../../Main";

export class AccessoryPlacer
{
	private _hitScene: Scene;
	private _raycaster: Raycaster;
	private readonly _plane = {
		q: new Vector3(0, 0, 0), // A point on the surface of the plane
		n: new Vector3(0, 1, 0) // The normal vector of the plane
	};

	constructor()
	{
		this.init();
	}

	private init()
	{
		this.initHitScene();
		this._raycaster = new Raycaster();
	}

	private initHitScene()
	{
		this._hitScene = new Scene();

		const bufferGeometry = new PlaneGeometry(300, 300, 1, 1);
		const material = new MeshBasicMaterial({color: 0xFF0000});
		const ground = new Mesh(bufferGeometry, material);


		// js doesn't seem to respect rotation...
		ground.rotation.x = -Math.PI/2;

		// so manually rotate the vertices
		// const rotationMatrix = new Matrix4();
		// rotationMatrix.makeRotationFromEuler(new Euler(-Math.PI/2, 0, 0))
		// //rotationMatrix.setRotationFromEuler(new Vector3(-Math.PI/2, 0, 0));

		// for (var v in geometry.vertices)
		// {
		// 	var vertex = geometry.vertices[v];
		// 	vertex.applyMatrix4(rotationMatrix);
		// 	geometry.vertices[v] = vertex;
		// 	//geometry.vertices[v] = rotationMatrix.multiplyVector3(geometry.vertices[v]);
		// }

		// //geometry.computeCentroids();
		// geometry.computeFaceNormals();
		// geometry.computeVertexNormals();


		this._hitScene.add(ground);
	}

	/**
	 * Returns the intersection point with the ground if any, or null otherwise.
	 * Very similar to NodePlacer::updatePosition
	 * @param mousePosition mouse position in NDC [-1, 1]
	 * @param camera
	 */
	public hitTest(mousePosition: number[], camera: PerspectiveCamera): Vector3
	{
		const x = mousePosition[0];
		const y = mousePosition[1];

		this._raycaster.setFromCamera(new Vector2(x, y), camera);
		const ray = this._raycaster.ray;

		const plane = this._plane;
		const t = plane.n.dot(plane.q.clone().sub(ray.origin)) / plane.n.dot(ray.direction);

		Main.getInstance().render = true;

		if (t < 0)
		{
			return null;
		}

		const hitPoint = ray.origin.add(ray.direction.multiplyScalar(t));

		return hitPoint;

	}
}